/*
 * @Author: JettyHuang
 * @LastEditors: JoanC-RB 15757871065@163.com
 * @Description:
 * @Date: 2020-12-25 14:53:23
 * @LastEditTime: 2025-12-25 20:27:22
 * @FilePath: /yft-b2c-web-h5/src/widget/App/AppServ.js
 */
import Request from 'utils/request';
import config from 'config/Config';
import { hex_md5, Encrypts } from 'utils/md5';
import { decryptParams } from 'utils/constants';

export default class {
  /**
   * 获取用户信息
   */
  static getUserInfo(ignore401) {
    return Request({
      url: `user/info/getUserInfo`,
      host: config.HOST_MALL,
      ignore401
    });
  }

  /**
   * 查询当前期数业绩
   */
  static getImgSolution() {
    return Request({
      url: `handle/getImgSolution`,
      host: config.HOST_PROMOTE
    });
  }

  // 记录播放
  static clickZan(params) {
    return Request({
      url: 'progress/tool/fabulous',
      host: config.HOST_PROMOTE,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 防疫信息
   */
  static getSystemConfig(system) {
    return Request({
      url: `${system}.json`,
      version: 'system',
      host: config.HOST_JSON,
      method: 'get',
      withCredentials: false,
      ignoreErr: true
    });
  }

  static getCardCodeInfo(params) {
    return Request({
      url: `personal/querySystemByCardCode`,
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 获取用权限点
   */
  static getEnterList() {
    return Request({
      url: `user/info/getEnterList`,
      host: config.HOST_MALL
    });
  }

  /**
   * 获取店铺信息
   */
  static getStoreInfo(tradeNo = '') {
    return Request({
      url: `store/info/get/store_info`,
      host: config.HOST_STORE,
      params: { tradeNo }
    });
  }

  /**
   * 获取个人中心用户信息
   */
  static getPersonalInfo() {
    return Request({
      url: `user/info/queryUserInfo`,
      host: config.HOST_MALL
    });
  }

  /**
   * 获取个人中心用户信息
   */
  static getCardTypeName(cardCode) {
    return Request({
      url: `member/info/getByCardCode/${cardCode}`,
      host: config.HOST_PROMOTE
    });
  }

  /**
   * 获取收藏产品id
   */
  static getCollectIds() {
    return Request({
      url: 'user/collection/collectionId/list',
      host: config.HOST_MALL
    });
  }

  /**
   * 获取用户支持的配货比例
   */
  static getUserdistriBution(params) {
    return Request({
      url: 'biz/tradecore/trade/query/distribution-rate',
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 获取折扣信息
   */
  static getDiscountList(params) {
    return Request({
      url: `discount/query/discount`,
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 获取基础信息
   */
  static getLearnPersonalInfo() {
    return Request({
      url: 'progress/learning/personal/info',
      host: config.HOST_PROMOTE
    });
  }
  static getSatisfiedInfo(type) {
    return Request({
      url: 'experience/getQuestionnaireSize',
      host: config.HOST_MALL,
      method: 'post_json',
      data: {
        type: type
      }
    });
  }
  static updataOpertion(type) {
    return Request({
      url: 'experience/addEvaluateOpertion',
      host: config.HOST_MALL,
      method: 'post_json',
      data: {
        type: type
      }
    });
  }

  /**
   *
   * 全局JSON配置开关请求
   *
   */
  static getHostJsonConfig() {
    return Request({
      url: `yofoto_global.json?${new Date().getTime()}`,
      host: config.HOST_JSON,
      version: 'web_json',
      withCredentials: false,
      ignoreErr: true
    });
  }

  /**
   *
   * 获取99微购json
   *
   */
  // static getGoodsFor99microShop() {
  //   return Request({
  //     // url: `goodsFor99Buy.json`,
  //     // host: 'https://bucket-prod.obs.cn-east-2.myhuaweicloud.com',
  //     // version: 'web_json',
  //     url: `promotion/purchase/json`,
  //     host: config.HOST_MALL,
  //     method: 'get',
  //     withCredentials: false,
  //     ignoreErr: true
  //   });
  // }

  // 可儿玫瑰更新健康顾问
  static setKerUpdateHealth(params) {
    return Request({
      url: `user/info/updateHealth?healthCode=${params}`,
      host: config.HOST_MALL,
      method: 'post_json',
      ignoreErr: true
    });
  }

  static getQuestionnaireList() {
    return Request({
      url: `experience/getQuestionnaireList`,
      host: config.HOST_MALL,
      method: 'get',
      ignoreErr: true
    });
  }
  //10个8更改健康顾问
  static setUpdateHealth(params) {
    return Request({
      url: `personal/updateDefaultHealth?healthCode=${params}`,
      host: config.HOST_MALL,
      method: 'post_json',
      ignoreErr: true
    });
  }
  static guidelines(id) {
    return Request({
      url: `item/biz/detail/recommendations/${id}`,
      host: config.HOST_MALL,
      method: 'get',
      ignoreErr: true
    });
  }
  static guidelinesList(params) {
    return Request({
      url: `item/queryByItemList?itemIds=${params}`,
      host: config.HOST_MALL,
      method: 'get',
      // params,
      ignoreErr: true
    });
  }

  /**
   * IM 签名
   */
  static getUserSig(data) {
    return Request({
      host: config.HOST_MALL,
      url: `im/getUserSig?identifier=${data}`,
      data: data
    });
  }

  // 解密敏感信息
  static getDecyptMsg(params) {
    params.md5Sign = encodeURIComponent(
      Encrypts(
        `${new Date().getTime()}#${hex_md5((params.id || params.cardCode) + decryptParams).toUpperCase()}`
      )
    );
    return Request({
      url: `decrypt/manager`,
      host: config.HOST_MALL,
      params
    });
  }
  static checkGoto(params) {
    return Request({
      host: config.HOST_MALL,
      url: 'survey/quest/supportVisitQuest',
      params
    });
  }
  static getMajorEvents(params) {
    return Request({
      host: config.HOST_MALL,
      url: 'basic/eventSet/query',
      params
    });
  }
  // 获取内容提醒消费VIP相关配置
  static queryVipReminderForFront() {
    return Request({
      url: `basic/reminder/queryVipReminderForFront`,
      host: config.HOST_MALL,
      method: 'get'
    });
  }
  // 获取 累计金额
  static getPaymentAmount(params) {
    return Request({
      url: `trade/getPaymentAmount`,
      host: config.HOST_MALL,
      method: 'get',
      params
    });
  }
  /**
   * 访客埋点
   */
  static injectVistor(data) {
    return Request({
      url: 'visitor/record/visitor',
      host: config.HOST_PROMOTE,
      method: 'post_json',
      ignore401: true,
      data
    });
  }
  /**
   * 获取分享自动排网
   */
  static getAutoSortResult(data) {
    return Request({
      url: 'content/poster/queryAutoSortResult',
      host: config.HOST_PROMOTE,
      method: 'get',
      data
    });
  }

  /**
   * 根据体系获取方案详情
   */
  static queryProjectDetail() {
    return Request({
      url: 'progress/learning/queryProjectDetail ',
      host: config.HOST_PROMOTE,
      method: 'get'
    });
  }

  /**
   * 根据卡号获取证件类型中其它类型是否显示标识
   * 1 展示 0 不展示
   */
  static queryIdentityType4(params) {
    return Request({
      url: `user/info/queryIdentityType4DisabledByCardCode`,
      host: config.HOST_MALL,
      method: 'get',
      params
    });
  }

  /**
   * 校验是否有线下活动资格
   */
  static meetValidate(id) {
    return Request({
      url: `meet/validate/${id}`,
      host: config.HOST_PROMOTE,
      method: 'get'
    });
  }

  // 获取是否显示肽素乳畅享卡
  static getShowBatchOrder() {
    return Request({
      url: `user/info/showBatchOrder`,
      host: config.HOST_MALL,
      method: 'POST'
    });
  }
  /**
   * 退出登录
   */
  static logout() {
    return Request({
      url: `user/login/logout`,
      host: config.HOST_MALL,
      method: 'get'
    });
  }

  /**
   * 验证生命周期赠券是否可用
   */
  static validateUserLifeCoupon(params) {
    return Request({
      url: `coupon/validate/userLifeCoupon`,
      host: config.HOST_MALL,
      params: params
    });
  }

  /**
   * 个人礼品仓 薇美云仓(新仓) 配置
   */
  static getWarehouseConfig() {
    return Request({
      url: `cloud/warehouse/cloudWareHouseConfig`,
      host: config.HOST_MALL
    });
  }
  /**
   * LY KER 获取物流详情
   */
  static getLogistics(tradeNo) {
    return Request({
      url: `delivery/manage/query/shippingLog/${tradeNo}`,
      host: config.HOST_MALL
    });
  }
  /**
   * 查询发货单列表
   */
  static getDeliveryList(tradeNo, fromQRCode) {
    const params = {};
    return Request({
      url: `tradecore/order/details/item-delivery/package${fromQRCode ? '/scan' : ''}/${tradeNo}`,
      host: config.HOST_MALL,
      params
    });
  }
  static queryLogistics(deliveryOrderNos) {
    return Request({
      url: `delivery/manage/batch/query/logistics?deliveryOrderNos=${deliveryOrderNos}`,
      host: config.HOST_MALL,
      method: 'get'
    });
  }
  static getUserInfoReItem() {
    return Request({
      url: `user/info/reItem`,
      host: config.HOST_MALL,
      method: 'post_json'
    });
  }

  // 提交售后预检查
  static afterSalePrecheck(params) {
    return Request({
      url: `tradecore/after-sale/apply/return/batch/precheck?tradeNos=${params.tradeNo}&applyType=${params.applyType}`,
      host: config.HOST_MALL,
      method: 'post_json',
      ignoreErr: true
    });
  }

  // 长轮询获取未读消息相关事件
  static queryHeadMsgForPull() {
    return Request({
      url: `message/queryHeadMsgForPull`,
      host: config.HOST_MALL,
      method: 'GET'
    });
  }
  /**
   * 修改消息状态为已读
   */
  static alterMsgStatus(params) {
    return Request({
      url: `message/updateStatus`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params,
      ignoreErr: true
    });
  }
  /**
   * 每已读一个消息，都调一下这个接口，供后台做统计使用
   */
  static updateCheckTime(params) {
    return Request({
      url: `marketing/remindRecord/updateCheckTime`,
      host: config.HOST_MALL,
      method: 'put_json',
      params
    });
  }
  // 查询云健康白名单
  static getHealthShowStatus() {
    return Request({
      url: `health/base/showStatus`,
      host: config.HOST_MALL,
      method: 'GET'
    });
  }

  // 查询个体户认证状态
  static queryCertificationStatus() {
    return Request({
      url: `third/individual/queryCertificationStatus`,
      host: config.HOST_MALL,
      method: 'GET'
    });
  }

  static longUrlByShortUrl(params) {
    return Request({
      url: `pro/create`,
      host: config.HOST_INTE,
      method: 'post_json',
      hiddenV1: true,
      data: params
    });
  }
  /**
   * 获取汇率信息
   * @param {object} params
   */
  static getExchangeRate(params) {
    return Request({
      url: `user/info/getExchangeByUserAndArea`,
      host: config.HOST_MALL,
      params,
      ignoreErr: true
    });
  }
  // 获取国际国际配置
  static getInternationalConfig() {
    return Request({
      url: `basic/international/hideSomeType`,
      host: config.HOST_MALL,
      method: 'GET'
    });
  }

  /**
   * 查询我的店铺信息
   */
  static queryMyStore() {
    return Request({
      url: '/store/info/queryMyStore',
      host: config.HOST_STORE,
      method: 'GET'
    });
  }
}



// WEBPACK FOOTER //
// ./src/widget/App/AppServ.js